import { useMemo } from 'react';
import { useCustomMask } from '@direct-frontend/components';

export const useEmailMask = () => {
    const emailMaskProps = useMemo(() => {
        return {
            mask: [...Array(255).fill(/[^ \s]/)],
            transformToUnmasked: (value: string) => value.trim(),
        };
    }, []);

    return useCustomMask(emailMaskProps);
};
